// Client-side log shipper. Buffers events and POSTs them to the api's
// /debug/client-log endpoint (visible via `docker logs stoat-api-1`).
//
// Use sparingly — primary purpose is diagnosing voice/WS reconnect issues
// reported by users. NOT a general analytics channel.
const ENDPOINT = "/api/debug/client-log";
const MAX_BUFFER = 200;
const FLUSH_INTERVAL_MS = 5000;
let currentUser;
const SESSION = (() => {
    try {
        const k = "stoat:logSession";
        let v = sessionStorage.getItem(k);
        if (!v) {
            v = Math.random().toString(36).slice(2, 10);
            sessionStorage.setItem(k, v);
        }
        return v;
    }
    catch {
        return Math.random().toString(36).slice(2, 10);
    }
})();
const BUFFER = [];
let flushing = false;
export function setClientLogUser(userId) {
    currentUser = userId;
}
export function clientLog(level, msg, data) {
    const event = {
        ts: Date.now(),
        level,
        msg,
        user_id: currentUser,
        session: SESSION,
        data,
    };
    BUFFER.push(event);
    while (BUFFER.length > MAX_BUFFER)
        BUFFER.shift();
    try {
        const fn = level === "error"
            ? console.error
            : level === "warn"
                ? console.warn
                : console.info;
        fn.call(console, "[clientLog]", msg, data ?? "");
    }
    catch {
        // swallow logging errors
    }
    if (level === "error")
        void flush();
}
async function flush() {
    if (flushing || BUFFER.length === 0)
        return;
    flushing = true;
    const batch = BUFFER.splice(0, BUFFER.length);
    try {
        await fetch(ENDPOINT, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ events: batch }),
            keepalive: true,
        });
    }
    catch {
        // Keep recent entries in case the endpoint comes back; drop the rest
        // so we don't grow unbounded if the api is down for a long time.
        BUFFER.unshift(...batch.slice(-50));
    }
    finally {
        flushing = false;
    }
}
if (typeof window !== "undefined") {
    window.addEventListener("error", (e) => {
        clientLog("error", "window.error", {
            message: e.message,
            filename: e.filename,
            lineno: e.lineno,
            colno: e.colno,
            stack: e.error?.stack,
        });
    });
    window.addEventListener("unhandledrejection", (e) => {
        const reason = e.reason;
        clientLog("error", "unhandledRejection", {
            reason: typeof reason === "object"
                ? String(reason)
                : reason,
            stack: typeof reason === "object" ? reason?.stack : undefined,
        });
    });
    setInterval(flush, FLUSH_INTERVAL_MS);
    window.addEventListener("beforeunload", () => {
        if (BUFFER.length === 0)
            return;
        try {
            const blob = new Blob([JSON.stringify({ events: BUFFER })], {
                type: "application/json",
            });
            navigator.sendBeacon?.(ENDPOINT, blob);
        }
        catch {
            // ignore
        }
    });
    clientLog("info", "client.ready", {
        ua: navigator.userAgent,
        url: location.href,
    });
}
